// extracted by mini-css-extract-plugin
export default {"stats":"Stats_stats__0vwlw","boxes":"Stats_boxes__U8cUF","container":"Stats_container__0o3qn","icon":"Stats_icon__Al2Al","loading":"Stats_loading__LZ+e9"};